module.exports = __webpack_public_path__ + "img/bl.8458b578.svg";